

const Task_Inputs = [
    {
        id: Math.random() * 10,
        name: "Task_Details",
        fields: [

            {
                id: Math.random() * 10,
                name: "Assignee",
                label: "Assignee",
                type: "InputDropForQuery",
                masterName: "User_Entry",
                // dropdowncontent: users_query,
            },

            {
                id: Math.random() * 10,
                name: "Priority",
                label: "Priority",
                type: "inputdrop",
                dropdowncontent: ["Heighest", "High", "Medium", "Low", "Lowest"],
            },


        ],
    },
];

export { Task_Inputs };
